import { Component, OnInit, AfterViewChecked, HostListener, Input } from '@angular/core';

import { Parser } from 'maf-web';

@Component({
  selector: 'grid-mosaico',
  template: `
    <div [ngStyle]="{'padding': '4px', 'grid-gap': margin+'px', 'grid-template-columns': 'repeat(auto-fill, minmax(' + minWidth + 'px,1fr))'}" class="grid-mosaico-lista">
      <ng-content></ng-content>
    </div>
  `,
  styles: [`
    .grid-mosaico-lista {
      display: grid;
      grid-auto-rows: 1px;
    }
    @media (max-width: 410px) {
      .grid-mosaico-lista {
        display: block;
      }
    }
  `]
})
export class GridMosaicoComponent implements OnInit, AfterViewChecked {

  @Input() minWidth: number = 200;
  @Input() margin: number = 16;

  constructor() {}

  ngOnInit() {
    this.resizeGridItens();
  }

  ngAfterViewChecked() {
    this.resizeGridItens();
  }

  @HostListener('window:resize', ['$event']) onResize() {
    this.resizeGridItens();
  }

  private resizeGridItens() {
    const gridItens: NodeListOf<HTMLElement> = document.querySelectorAll('.grid-mosaico-lista-item');
    if (gridItens == null) {
      return false;
    }
    for (const gridItem of gridItens as any) {
      this.resizeGridItem(gridItem);
    }
  }

  private resizeGridItem(item: HTMLElement) {
    item.removeAttribute('style');
    const grid = document.querySelector('.grid-mosaico-lista');
    if (grid == null) {
      return false;
    }
    const rowHeight = Parser.strToInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
    const rowGap = Parser.strToInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));
    const heightCotainer = item.querySelector('.grid-mosaico-lista-item-conteudo').getBoundingClientRect().height;
    const rowSpan = Math.ceil((heightCotainer + rowGap) / (rowHeight + rowGap));
    item.style.gridRowEnd = 'span ' + rowSpan;
  }

}
